import { useEffect } from 'react';
import enviro from 'enviro';
import Raven from 'raven-js';
import { NetworkStatus } from '@apollo/client';
import { useDataSyncApps } from './useDataSyncApps';
import { getReconnectionConfig } from '../utils/getReconnectionConfig';
import { useDashworksAppIds } from './useDashworksAppIds';
import { useUnifiedAccountSupportedApps } from './useUnifiedAccountSupportedApps';
export const useServiceComponent = ({
  metadata,
  url
}) => {
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const status = metadata === null || metadata === void 0 ? void 0 : metadata.status;
  const {
    data: unifiedAccountApps,
    loading: unifiedAccountAppsLoading,
    error: unifiedAccountAppsError,
    networkStatus: unifiedAccountAppsNetworkStatus
  } = useUnifiedAccountSupportedApps();
  const {
    data: dataSyncApps,
    isLoading: dataSyncAppsLoading,
    error: dataSyncAppsError,
    networkStatus: dataSyncAppsNetworkStatus
  } = useDataSyncApps();
  const {
    data: dashworksAppIds,
    isLoading: dashworksAppIdsLoading,
    error: dashworksAppIdsError,
    networkStatus: dashworksAppsNetworkStatus
  } = useDashworksAppIds();
  useEffect(() => {
    if (!appId) {
      const err = new Error('ReconnectButton requires appId');
      Raven.captureException(err);
      if (!enviro.deployed()) {
        console.error(err);
        throw err;
      }
    }
  }, [appId]);
  const isUnifiedAccountSupportedApp = unifiedAccountApps.some(({
    appId: unifiedAccountSupportedAppId
  }) => unifiedAccountSupportedAppId === appId);
  const isDataSyncApp = dataSyncApps.some(({
    appId: dataSyncAppId
  }) => dataSyncAppId === appId);
  const isDashworksApp = dashworksAppIds.some(dashworkAppId => dashworkAppId === appId);
  const reconnectionConfig = getReconnectionConfig({
    appId,
    isDataSyncApp,
    isDashworksApp,
    isUnifiedAccountSupportedApp,
    hasUrl: !!url
  });
  const {
    statusesForDisplaying,
    serviceComponent: ServiceComponent = null
  } = reconnectionConfig || {};
  const isVisible = !(statusesForDisplaying !== null && statusesForDisplaying !== void 0 && statusesForDisplaying.length) || statusesForDisplaying.includes(status);
  return {
    serviceComponent: isVisible ? ServiceComponent : null,
    loading: dataSyncAppsLoading || dashworksAppIdsLoading || unifiedAccountAppsLoading,
    error: dataSyncAppsError || dashworksAppIdsError || unifiedAccountAppsError,
    isLoaded: dataSyncAppsNetworkStatus >= NetworkStatus.ready && dashworksAppsNetworkStatus >= NetworkStatus.ready && unifiedAccountAppsNetworkStatus >= NetworkStatus.ready
  };
};